import React from 'react';
import {useReactFlow} from 'reactflow';

import {DEFAULT_FIT_VIEW_SETTINGS} from 'registry/entity-map/EntityMapConstants';
import {useEntityMapSelector} from 'registry/entity-map/EntityMapMachineProvider';
import BaseControlButton from 'ui-library/reactflow/controls/BaseControlButton';
import HorizontalControls from 'ui-library/reactflow/controls/HorizontalControls';

/**
 * Control button for centering the view port on the main entity node.
 * @constructor
 */
function EntityMapCenterButton(): JSX.Element {
  const entityId = useEntityMapSelector((s) => s.context.entityId);
  const {fitView} = useReactFlow();
  return (
    <BaseControlButton
      icon="crosshairs"
      tooltip="Center on main entity"
      onClick={() => fitView({nodes: [{id: entityId}], ...DEFAULT_FIT_VIEW_SETTINGS})}
    />
  );
}

/**
 * Controls for the entity map.
 *
 * Includes the standard zoom and "fit view" controls as well as a "center main node" button.
 * @constructor
 */
export default function EntityMapControls(): JSX.Element {
  return <HorizontalControls additionalControls={<EntityMapCenterButton />} />;
}
